import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "fw-medium" }
const _hoisted_9 = { class: "fw-medium" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_11 = { class: "dropdown-menu dropdown-block" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Mes clients affectés")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "search-bg svg-color pt-3",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black",
            placeholder: "Rechercher un client"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Numéro client"),
              _createElementVNode("th", null, "Nom / Raison sociale"),
              _createElementVNode("th", null, "IFU"),
              _createElementVNode("th", null, "Téléphone"),
              _createElementVNode("th", null, "Statut"),
              _createElementVNode("th", { class: "text-uppercase fw-medium fs-13 pt-0 text pe-0" }, " ACTIONS ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_ctx.clients.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, _cache[5] || (_cache[5] = [
                  _createElementVNode("td", {
                    colspan: "5",
                    class: "text-center text-muted"
                  }, " Aucun client affecté ", -1)
                ])))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: client.id
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(client.numeroClient), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(client.nomClient && client.prenomClient
                    ? `${client.nomClient} ${client.prenomClient}`
                    : client.raisonSociale), 1),
                _createElementVNode("td", null, _toDisplayString(client.ifu), 1),
                _createElementVNode("td", null, _toDisplayString(client.telephone1), 1),
                _createElementVNode("td", null, _toDisplayString(client.statut == 1 ? 'Personne physique' : 'Personne morale'), 1),
                _createElementVNode("td", _hoisted_10, [
                  _cache[9] || (_cache[9] = _createElementVNode("button", {
                    class: "btn dropdown-toggle btn-primary",
                    type: "button",
                    "data-bs-toggle": "dropdown"
                  }, " Actions ", -1)),
                  _createElementVNode("ul", _hoisted_11, [
                    (_ctx.checkPermission('EditClient'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                          _createVNode(_component_router_link, {
                            to: { name: 'EditClient', params: { id: client.id } },
                            class: "dropdown-item"
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "flaticon-pen me-8" }, null, -1),
                              _createTextVNode(" Modifier ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.checkPermission('ViewClient'))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                          _createVNode(_component_router_link, {
                            to: { name: 'ViewClient', params: { id: client.id } },
                            class: "dropdown-item"
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "flaticon-eye me-8" }, null, -1),
                              _createTextVNode(" Détails ")
                            ])),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'ClientsTransaction', params: { id: client.id } },
                        class: "dropdown-item"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createElementVNode("i", { class: "flaticon-list me-8" }, null, -1),
                          _createTextVNode(" Transactions ")
                        ])),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_PaginationComponent, {
        class: "mt-20",
        page: _ctx.page,
        totalPages: _ctx.totalPages,
        totalElements: _ctx.totalElements,
        limit: _ctx.limit,
        onPaginate: _ctx.handlePaginate
      }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
    ])
  ]))
}